import React from "react";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import ListSubheader from "@mui/material/ListSubheader";
import InputAdornment from "@mui/material/InputAdornment";

import { Select } from "@src/components";
import { Input } from "@src/components/Input/Input";
import { IRestaurantGroup } from "@src/store/app_manager/types";
import { ReactComponent as SearchIcon } from "@src/assets/icons/search.svg";
import { setCurrentRestaurantGroupId } from "@src/store/app_manager/actionCreators";
import { ReactComponent as RestGroupIcon } from "@src/assets/icons/resturantGroupIcon.svg";
import { selectAllRestaurantGroups, selectCurrentRestaurantGroupId, } from "@src/store/app_manager/selector";


export const LocationGroupSelect: React.FC<any> = ({ }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const restaurantGroups = useSelector(selectAllRestaurantGroups);
  const currRestGroupId = useSelector(selectCurrentRestaurantGroupId);


  const [restaurantGroupId, setRestaurantGroupId] = React.useState("");
  const [searchResGroup, setResGroupSearch] = React.useState("");

  const handleRestGroup = (e: any): void => {
    handleRestaurantGroupId(e.target.value);
  };

  const handleResGroupSearch = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setResGroupSearch(e.target.value);
  };

  const handleRestaurantGroupId = React.useCallback(
    (restId: string): void => {
      const allLocationsList = restaurantGroups?.find(
        (el: IRestaurantGroup) => el.id === restId
      )?.locations;

      dispatch(setCurrentRestaurantGroupId(restId, allLocationsList ?? []));

      const url_arr = location.pathname.split("/");

      if (url_arr.indexOf("configure") !== -1) {
        navigate("/app/menu");
      }
    },
    [currRestGroupId]
  );

  const filterResGroups = React.useMemo(() => {
    if (restaurantGroups.length) {
      return restaurantGroups.filter((item: any) =>
        item?.name.toLowerCase().includes(searchResGroup.toLocaleLowerCase())
      );
    }
    return [];
  }, [searchResGroup, restaurantGroups]);

  React.useEffect(() => {
    setRestaurantGroupId(currRestGroupId);
  }, [currRestGroupId]);

  return (
    <Select
      value={restaurantGroupId}
      onChange={handleRestGroup}
      MenuProps={{
        autoFocus: false,
        PaperProps: {
          sx: {
            borderRadius: "10px"
          }
        }
      }}
      sx={{
        position: "relative",
        '& .MuiSelect-select': {
          backgroundColor: "white",

        },
        '& .MuiSelect-root': {
          backgroundColor: "white",
        }
      }}
      renderValue={(value: unknown) => {
        const findItem = filterResGroups?.find(restGroup => restGroup.id === value);
        return (
          <Box display="flex" gap="15px" alignItems="center">
            <RestGroupIcon />
            <Typography fontSize="18px" fontWeight="600">{findItem?.name}</Typography>
          </Box>
        );
      }}
    >
      <ListSubheader
        sx={{
          margin: 0,
          padding: 0,
          position: "sticky",
          top: 0,
          left: 0,
          width: "100%"
        }}
      >
        <Input
          autoFocus
          fullWidth
          inputSize="l"
          size="small"
          value={searchResGroup}
          placeholder="Search"
          onChange={handleResGroupSearch}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>}
          onKeyDown={(e) => {
            if (e.key !== "Escape") {
              e.stopPropagation();
            }
          }}
        />
      </ListSubheader>
      {filterResGroups.length ? (
        filterResGroups?.map((location: any) => (
          <MenuItem key={location.id} value={location.id}>
            {location.name}
          </MenuItem>
        ))
      ) : (
        <Typography textAlign="center">Пусто</Typography>
      )}
    </Select>
  );
};